import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ReactiveFormsModule, UntypedFormBuilder } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
    selector: 'app-search-field',
    templateUrl: './search-field.component.html',
    styleUrls: ['./search-field.component.scss'],
    imports: [TranslateModule, ReactiveFormsModule]
})
export class SearchFieldComponent implements OnInit {

  @Output()
  public searchTextChanged = new EventEmitter<string>();

  @Input()
  public placeholderText = 'i18n.shared.search';

  public searchForm = this.fb.group({
    filter: [''],
  });

  constructor(private fb: UntypedFormBuilder) { }

  ngOnInit() {
    this.searchForm.get('filter').valueChanges
      .pipe(
        debounceTime(500),
        distinctUntilChanged()
      )
      .subscribe(val => {
        this.searchTextChanged.emit(val);
      })
  }
}
